/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React, { Component } from 'react';
import { translate } from '../../../../api/utils/i18nHelper';
import QuickAdd from '../../molecules/basket/QuickAdd';

class CartListHeaderMobile extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { i18n, title, clearCart, quickAddItems, onInputChange, addToCart } = this.props;

        return (
            <React.Fragment>
                <div className="cart__content--header-mobile hide-desktop">
                    <div className="row">
                        <div className={'cart__content--header-mobile-title col-xs-' + (clearCart ? '6' : '12')}>
                            <h2 className="p-margin-none">{title}</h2>
                        </div>

                        {clearCart && (
                            <div className="cart__content--header-empty-cart col-xs-6">
                                <div className="cart__content--header-mobile-empty-card">
                                    <a href="#" className="p-align-self-end text-right" onClick={clearCart}>
                                        <span className="svg-trash-can"></span>
                                        {translate(i18n, 'Clear cart')}
                                    </a>
                                </div>
                            </div>
                        )}
                    </div>

                    {quickAddItems && (
                        <div className="cart__content--header-mobile-quick-add">
                            <QuickAdd
                                handleInputChange={onInputChange}
                                handleSubmit={addToCart}
                                i18n={i18n}
                                autocompleteItems={quickAddItems}
                                placeholder={translate(i18n, 'Add to cart')}
                            />
                        </div>
                    )}
                </div>
            </React.Fragment>
        );
    }
}

export default CartListHeaderMobile;
